module.exports = __webpack_public_path__ + "img/a warm meal_.d4b420aa.png";